import { useEffect } from 'react';
import { GROUP_ORDER_CLOSE_CART } from 'bento-ordering/group_ordering/actions/actionTypes';
import { useDispatch, useSelector } from 'react-redux';
import { selectCartGroupOrderDeadline } from 'bento-ordering/cart/selectors/index';
import { differenceBetweenTime } from 'bento-ordering/group_ordering/utils';

const useSetTimeoutForOrder = () => {
  const dispatch = useDispatch();
  const groupOrderingDeadline = useSelector(selectCartGroupOrderDeadline);
  useEffect(() => {
    let triggerSnackbar;
    if (groupOrderingDeadline) {
      triggerSnackbar = setTimeout(
        () => dispatch({ type: GROUP_ORDER_CLOSE_CART }),
        differenceBetweenTime(groupOrderingDeadline)
      );
    }
    return () => {
      if (triggerSnackbar) {
        clearTimeout(triggerSnackbar);
      }
    };
  }, [groupOrderingDeadline, dispatch]);
};

export default useSetTimeoutForOrder;
